import CreditCardOffOutlinedIcon from "@mui/icons-material/CreditCardOffOutlined";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import { Box, Button, Chip, Divider, Typography } from "@mui/material";
import { useTranslations } from "use-intl";

import CasaLogo from "../../logo/CasaLogo";
import { logout } from "../../../keycloak";
import { InvoicePaymentStatus } from "../../../interfaces/User";
import styles from "./PaymentRestriction.module.scss";

interface PaymentRestrictionProps {
  invoicePaymentStatus?: InvoicePaymentStatus | null;
}

const PaymentRestriction = ({ invoicePaymentStatus }: PaymentRestrictionProps) => {
  const t = useTranslations("ui");
  const subtitle =
    invoicePaymentStatus?.state === "overdue" && invoicePaymentStatus.dueDate
      ? t("paymentRestriction.overdueInvoice", {
          dueDate: invoicePaymentStatus.dueDate,
          count: invoicePaymentStatus.daysOverdue ?? 0,
        })
      : t("paymentRestriction.overdueInvoices");

  return (
    <Box className={styles.container}>
      <Box className={styles.header}>
        <CasaLogo />
      </Box>

      <Box className={styles.body}>
        <Box className={styles.card}>
          <Box className={styles.iconWrapper}>
            <CreditCardOffOutlinedIcon className={styles.icon} />
          </Box>

          <Chip
            label={t("paymentRestriction.chip")}
            size="small"
            className={styles.chip}
            sx={{
              bgcolor: "error.light",
              color: "error.dark",
              fontWeight: 400,
            }}
          />

          <Typography variant="h5" className={styles.title}>
            {t("paymentRestriction.title")}
          </Typography>

          <Typography variant="body2" className={styles.subtitle}>
            {subtitle}
          </Typography>

          <Divider className={styles.divider} />

          <Box className={styles.supportBox}>
            <MailOutlineIcon
              fontSize="small"
              sx={{ color: "text.secondary" }}
            />
            <Box>
              <Typography variant="body2" color="text.secondary">
                {t("accessRestriction.needHelp")}
              </Typography>
              <Typography variant="body2" fontWeight={600} color="text.primary">
                {"care@casaretail.ai"}
              </Typography>
            </Box>
          </Box>

          <Button
            variant="outlined"
            color="error"
            size="small"
            startIcon={<LogoutOutlinedIcon />}
            onClick={logout}
            className={styles.logoutButton}
          >
            {t("accessRestriction.signOut")}
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default PaymentRestriction;
